import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import Header from '../../../components/Header/index'
import NotificationItem from './NotificationItem'

const NotificationDetail = () => {
  let location = useLocation()
  const navigate = useNavigate()
  const notificationData = location?.state.notificationData
  const selectedTesis = location?.state.selectedTesis
  const item = location?.state.item

  const handleBackButton = () => {
    navigate('/hobiNotification', {
      state: {
        notificationData: notificationData,
        selectedTesis: selectedTesis,
      },
    })
  }

  return (
    <>
      <div
        className='scrollDiv'
        style={{
          padding: '0 0 2rem 0',
        }}
      >
        <div
          style={{
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
            zIndex: 999,
          }}
        >
          <Header backButton onClick={handleBackButton} rules={true} />

          <div className='container' style={{padding: '1rem 1rem 0 1rem'}}>
            <NotificationItem
              title={item.baslik}
              date={item.created_at}
              desc={item.aciklama.split('\n').map((str) => (
                <p key={str}>{str}</p>
              ))}
              adds={item.dosya}
              detay={true}
              dividerVisible={false}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default NotificationDetail
